// Libraries
import _ from 'lodash';

interface ValidationArgs {
  form: any;
  field: string;
  message: string;
}

export interface ValidationErrors {
  [field: string]: string;
}

const Validation = {
  requiredStringField: ({form, field, message}: ValidationArgs): ValidationErrors => {
    if (!_.get(form.values, field) || _.get(form.values, field) === '') {
      return {[field]: message};
    }
    return {};
  },
  // Note: Empty strings will pass the StringFieldMinLength validation. Call the requiredStringField validation separately as needed.
  StringFieldMinLength: ({
    form,
    field,
    message,
    minLength,
  }: ValidationArgs & {minLength: number}): ValidationErrors => {
    const value = _.get(form.values, field);
    if (value && value.length < minLength) {
      return {[field]: message};
    }
    return {};
  },
  requiredArrayField: ({form, field, message}: ValidationArgs): ValidationErrors => {
    if (!_.get(form.values, field) || _.get(form.values, field).length === 0) {
      return {[field]: message};
    }
    return {};
  },
};

export default Validation;
